import { useEffect, useState } from "react";
import { Trash2 } from "lucide-react";
import { toast } from "sonner";
import { adminApi, errMsg } from "../../lib/api";
import { SUBJECTS } from "../../lib/format";
import { ConfirmDelete } from "./ConfirmDelete";

const STATUS = [["yeni", "Yeni"], ["okundu", "Okundu"], ["cozuldu", "Çözüldü"]];
const when = (iso) => new Date(iso).toLocaleString("tr-TR", { dateStyle: "medium", timeStyle: "short" });

export const MessagesManager = () => {
  const [items, setItems] = useState([]);
  const [filter, setFilter] = useState("all");
  const [toDelete, setToDelete] = useState(null);

  const load = () => adminApi.get("/admin/messages").then((r) => setItems(r.data));
  useEffect(() => {
    load();
  }, []);

  const setStatus = async (m, status) => {
    try {
      await adminApi.patch(`/admin/messages/${m.id}`, { status });
      load();
    } catch (e) {
      toast.error(errMsg(e));
    }
  };

  const remove = async () => {
    await adminApi.delete(`/admin/messages/${toDelete.id}`);
    setToDelete(null);
    load();
  };

  const shown = items.filter((m) => filter === "all" || m.status === filter);

  return (
    <div>
      <h2 className="font-display text-2xl font-bold text-slate-800">Gelen Mesajlar</h2>
      <p className="text-sm text-slate-500 mb-4">Sakinlerden gelen dilek/şikayetler ve iletişim formu mesajları.</p>
      <div className="flex gap-2 mb-4 flex-wrap">
        {[["all", "Tümü"], ...STATUS].map(([k, l]) => (
          <button key={k} onClick={() => setFilter(k)} data-testid={`msg-filter-${k}`}
            className={`px-4 py-2 rounded-full text-sm font-semibold ${filter === k ? "bg-[#1B4332] text-white" : "bg-white border border-black/10 text-slate-600"}`}>{l}</button>
        ))}
      </div>
      <div className="space-y-3" data-testid="admin-messages-list">
        {shown.length === 0 && <p className="text-slate-500 bg-white rounded-3xl p-6 border border-black/5">Mesaj yok.</p>}
        {shown.map((m) => (
          <div key={m.id} className={`bg-white rounded-3xl border p-5 ${m.status === "yeni" ? "border-[#E07A5F]/50" : "border-black/5"}`} data-testid={`admin-message-${m.id}`}>
            <div className="flex flex-wrap items-center gap-2 text-xs">
              <span className="px-2.5 py-1 rounded-full bg-[#D8F3DC] text-[#1B4332] font-bold">{SUBJECTS[m.subject]}</span>
              <span className="font-bold text-slate-700">{m.name}</span>
              {m.villa_no && <span className="text-slate-500">{m.villa_no} · {m.role}</span>}
              {m.contact && <span className="text-slate-500">{m.contact}</span>}
              <span className="text-slate-400 ml-auto">{when(m.created_at)}</span>
            </div>
            <p className="text-slate-700 mt-3 whitespace-pre-line">{m.body}</p>
            <div className="flex flex-wrap gap-2 mt-4">
              {STATUS.map(([k, l]) => (
                <button key={k} onClick={() => setStatus(m, k)} data-testid={`msg-status-${k}-${m.id}`}
                  className={`px-3 py-1.5 rounded-full text-xs font-bold ${m.status === k ? "bg-[#1B4332] text-white" : "bg-slate-100 text-slate-600 hover:bg-slate-200"}`}>{l}</button>
              ))}
              <button onClick={() => setToDelete(m)} className="ml-auto px-3 py-1.5 rounded-full text-xs font-bold bg-red-50 text-red-600 inline-flex items-center gap-1" data-testid={`msg-delete-${m.id}`}>
                <Trash2 size={12} /> Sil
              </button>
            </div>
          </div>
        ))}
      </div>
      <ConfirmDelete open={!!toDelete} title={toDelete ? SUBJECTS[toDelete.subject] : ""} onCancel={() => setToDelete(null)} onConfirm={remove} />
    </div>
  );
};
